import axios from "axios";

export default {
    fetchLesson(id) {
        return axios.get('lessons/' + id + '?expand=isCompleted,isLocked,isOrderLocked,isPerDayLocked,isPerPartialPayLocked')
            .then(response => {
                return response.data
            })
    },

    fetchLessons(courseId) {
        return axios.get('lessons?expand=isCompleted,isLocked,isOrderLocked,isPerDayLocked,isPerPartialPayLocked&sort=pos&filter[idcourse]=' + courseId)
            .then(response => {
                return response.data
            })
    },

    fetchLessonsIds(courseId) {
        return axios.get('lessons?sort=pos&fields=idlesson,pos&filter[idcourse]=' + courseId)
            .then(response => {
                return response.data
            })
    },

    fetchElements(lessonId) {
        return axios.get('/elements?sort=pos&filter[idlesson]=' + lessonId)
            .then(response => {
                return response.data
            })
    },

    fetchTests(lessonId) {
        return axios.get('/tests?sort=pos&filter[idlesson]=' + lessonId)
            .then(response => {
                return response.data
            })
    },

    fetchTest(testId) {
        return axios.get('/tests/' + testId)
            .then(response => {
                return response.data
            })
    },


    getElementsTypes() {
        return [
            {idelementtype: 'video', elementtype: 'Видео урок'},
            {idelementtype: 'grammar', elementtype: 'Грамматика'},
            {idelementtype: 'vocabulary', elementtype: 'Словарик'},
            {idelementtype: 'test', elementtype: 'Тест-задание'},
            {idelementtype: 'materials', elementtype: 'Дополнительные материалы'},
            {idelementtype: 'addpack', elementtype: 'Дополнительный пакет - материалы'},
            {idelementtype: 'addpack-video', elementtype: 'Дополнительный пакет - видео'},
            {idelementtype: 'flashcards', elementtype: 'Флешкарты'},
            {idelementtype: 'game', elementtype: 'Игра'},
        ]
    }
}
